import { KEY_CODES } from '@/utils/constants';
import { generateUniqueId } from '@/utils/helper';

export default {
  name: 'AddMenuOption',
  data() {
    return {
      items: [],
      max: 0,
      min: 0,
      name: '',
      note: '',
    };
  },
  computed: {
    disableAdd() {
      const allNameFilled = this.items?.every(({ name }) => name);
      const validationItems = [
        this.name,
        this.items?.length,
        allNameFilled,
      ];
      return validationItems.some((item) => !item);
    },
    hasEmptyItems() {
      return this.items?.some(({ name }) => !name) || false;
    },
    hasMultipleItems() {
      return this.itemsCount > 1;
    },
    itemsCount() {
      return this.items?.length;
    },
    minMax() {
      return this.max || 99;
    },
  },
  mounted() {
    this.onAddNewItem();
  },
  watch: {
    max(newVal, oldVal) {
      if (newVal !== oldVal && this.min > +newVal) {
        this.min = +newVal;
      }
    },
  },
  methods: {
    onCreateOption() {
      const option = {
        name: this.name,
        items: this.items?.map(({ price, ...props }) => ({ ...props, price: price || 0 })) || [],
        note: this.note,
        price: 0,
        rules: {
          max: this.max,
          min: this.min,
        },
      };
      this.$emit('add-option', option);
    },
    onAddNewItem(viewIndex = this.items.length) {
      const index = generateUniqueId();
      this.items.splice(viewIndex + 1, 0, {
        index,
        name: '',
        price: null,
      });
    },
    onCheckAndAddNewItem($event, viewIndex, key) {
      if (this.hasEmptyItems) {
        return;
      }
      const isLastItem = this.items?.length === viewIndex + 1;
      if (isLastItem) {
        this.onAddNewItem(viewIndex);
      }
      this.onFocusNext($event, viewIndex, key);
    },
    onFocus($event, key) {
      const {
        isComposing,
        keyCode,
        target: {
          selectionEnd,
          value,
        },
      } = $event;
      if (keyCode === KEY_CODES.LEFT && Number.isInteger(selectionEnd) && selectionEnd >= 0) {
        // eslint-disable-next-line no-param-reassign
        $event.target.selectionStart = selectionEnd - 1;
        // eslint-disable-next-line no-param-reassign
        $event.target.selectionEnd = selectionEnd - 1;
        return;
      }
      if (
        keyCode === KEY_CODES.RIGHT
        && Number.isInteger(selectionEnd)
        && selectionEnd < value.length
      ) {
        // eslint-disable-next-line no-param-reassign
        $event.target.selectionStart = selectionEnd + 1;
        // eslint-disable-next-line no-param-reassign
        $event.target.selectionEnd = selectionEnd + 1;
        return;
      }
      if (!key || isComposing) {
        return;
      }
      this.$nextTick(() => {
        this.$refs[key][0].focus();
      });
    },
    onFocusNext($event, viewIndex = 0, key) {
      const isLastItem = this.items?.length === viewIndex + 1;
      if (!key || isLastItem || $event?.isComposing) {
        return;
      }
      const index = this.items[viewIndex + 1]?.index;
      this.onFocusToIndex($event, key, index);
    },
    onFocusPre($event, viewIndex = 0, key) {
      const isFirstItem = viewIndex === 0;
      if (!key || isFirstItem || $event?.isComposing) {
        return;
      }
      const index = this.items[viewIndex - 1]?.index;
      this.onFocusToIndex($event, key, index);
    },
    onFocusToIndex($event, key, index) {
      if (!key || !Number.isInteger(index)) {
        return;
      }
      this.onFocus($event, `${key}-${index}`);
    },
    onRemoveItem(itemViewIndex) {
      if (!Number.isInteger(itemViewIndex)) {
        return;
      }
      this.items.splice(itemViewIndex, 1);
    },
  },
};
